import React from 'react'
import styled from "styled-components";
import {Image, Divider, Message} from 'semantic-ui-react';

import { __ } from '~/i18n'
import SelectListItem from '~/components/select-list-item'
import { formatMoney } from '~/utils/money'


const NameContainer = styled.span`
  line-height: 42px;
  display: inline-block;
`;

const PriceContainer = styled.span`
  line-height: 42px;
  display: inline-block;
  font-size: 14px;
  color: #222222;
  text-align: right;
  line-height: 24px;
  font-weight: bold;
  margin-top: 10px;
  margin-left: auto;
`;

const GrayInactiveImage = styled(({ active, ...rest }) => <Image {...rest} />)`
  &.ui.image {
    ${props => props.active ? '' : 'filter: gray;' }
    ${props => props.active ? '' : '-webkit-filter: grayscale(1);'}
    ${props => props.active ? '' : 'filter: grayscale(1);'}
  }
`;

export default class ShippingMethod extends React.PureComponent {
  handleClick = (e) => {
    const { selectMethod, shippingMethod } = this.props;

    if(selectMethod) {
      selectMethod(shippingMethod);
    }
  };

  render() {
    const { active, image, price, name, instructions, shippingSettings } = this.props;
    return (
      <SelectListItem
        size='big' active={ active }
        onClick={ this.handleClick }
        title={[
          image ? <GrayInactiveImage active={ active } key='image' style={{height: 42}} verticalAlign='middle' src={ image } /> : null,
          name ? <NameContainer key='name'>{ name }</NameContainer> : null,
          price && price.price ? <PriceContainer key='price'>{ formatMoney(price.price) }</PriceContainer> : <PriceContainer key='price'>{ __("Free") }</PriceContainer>,
        ]}
      >
        { active && (instructions || shippingSettings) ?
          <div>
            <Divider />
            { instructions ?
              <Message size='mini'>
                <Message.Header>{ __('Instructions') }</Message.Header>
                <p>
                  { instructions }
                </p>
              </Message>
            : null }
            { shippingSettings }
          </div>
          : null
        }
      </SelectListItem>
    )
  }
}
